<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Rate Limiters</v-card-title>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="rate_limiters"
        :search="search"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 50, 100, 250, -1], // -> Add this example
          showFirstLastPage: false,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >New Item</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.id"
                          label="ID"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.packets_per_second"
                          label="Packets Per Second"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.comment"
                          label="Comment"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";

export default {
  mounted() {
    api
      .query("rate_limiters")
      .then((response) => (this.rate_limiters = response.data.rate_limiters))
      .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
      .finally(() => (this.loading = false));
  },
  data: () => ({
    selected: [],
    headers: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Packets per Second", value: "packets_per_second" },
      { text: "Comment", value: "comment" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    rate_limiters: [],
    errors: [],
    loading: true,
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: "",
      packets_per_second: null,
      comment: "",
    },
    defaultItem: {
      id: "",
      packets_per_second: null,
      comment: "",
    },
    search: "",
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.rate_limiters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        api.delete("rate_limiters/" + item.id).then((response) => {
          const index = this.rate_limiters.indexOf(item);
          this.rate_limiters.splice(index, 1);
        });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        api
          .post("rate_limiters/" + this.editedItem.id, {
            packets_per_second: this.editedItem.packets_per_second,
            comment: this.editedItem.comment,
          })
          .then((response) => {
            Object.assign(
              this.rate_limiters.find((val) => val.id == response.data.id),
              response.data
            );
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      } else {
        api
          .post("rate_limiters", {
            packets_per_second: this.editedItem.packets_per_second,
            comment: this.editedItem.comment,
          })
          .then((response) => {
            this.rate_limiters.push(response.data);
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      }
      this.close();
    },
  },
};
</script>
